import { VariantProps } from '@stitches/react'

import { StyledGrafbaseAnimated } from './grafbase-animated.styles'

export const GrafbaseAnimated = ({
  size = 'small',
  speed = 'default'
}: {
  size?: VariantProps<typeof StyledGrafbaseAnimated>['size']
  speed?: VariantProps<typeof StyledGrafbaseAnimated>['speed']
}) => {
  return (
    <StyledGrafbaseAnimated size={size} speed={speed}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 19">
        <path
          id="grafbase-animated-layer-g"
          fill="#FCFCFC"
          fillRule="evenodd"
          d="M9.776.928a.71.71 0 0 1-.317.953l-7.02 3.51 6.71 3.356 6.71-3.355-2.564-1.28-3.832 1.915a.71.71 0 1 1-.635-1.272l4.15-2.072a.71.71 0 0 1 .634 0l4.155 2.072a.71.71 0 0 1 0 1.272l-8.29 4.145a.71.71 0 0 1-.327.075.709.709 0 0 1-.327-.075L.532 6.027a.71.71 0 0 1 0-1.272L8.822.61a.71.71 0 0 1 .954.318Z"
          clipRule="evenodd"
        />

        <path
          id="grafbase-animated-layer-mid"
          fill="#FCFCFC"
          fillRule="evenodd"
          d="M.225 9.215a.71.71 0 0 1 .954-.317l7.973 3.986 7.973-3.986a.71.71 0 0 1 .635 1.27l-8.29 4.146-.318.075a.712.712 0 0 1-.318-.075L.544 10.17a.71.71 0 0 1-.319-.954Z"
          clipRule="evenodd"
        />

        <path
          id="grafbase-animated-layer-bottom"
          fill="#FCFCFC"
          fillRule="evenodd"
          d="M.226 13.36a.711.711 0 0 1 .953-.318l7.973 3.987 7.973-3.987a.71.71 0 0 1 .635 1.272L9.47 18.46a.71.71 0 0 1-.636 0l-8.29-4.145a.712.712 0 0 1-.319-.954Z"
          clipRule="evenodd"
        />
      </svg>
    </StyledGrafbaseAnimated>
  )
}
